module.exports = __webpack_public_path__ + "img/icon-sort-down.3664a374.svg";